<template>
  <div>
    <Heading />
    <v-row justify="center" class="mx-4">
      <BrandSelect @brand="setBrand" />
      <v-col md="1"></v-col>
      <EcuSelect ref="ecu" />
    </v-row>
    <SearchBtn @click="onClick" />
  </div>
</template>

<script>
import Heading from "@/components/app/Home/Heading.vue";
import BrandSelect from "@/components/app/Home/BrandSelect.vue";
import EcuSelect from "@/components/app/Home/EcuSelect.vue";
import SearchBtn from "@/components/app/Home/SearchBtn.vue";

export default {
  name: "Home",
  components: {
    Heading,
    EcuSelect,
    BrandSelect,
    SearchBtn,
  },
  methods: {
    onClick() {
      this.$refs.ecu.onClick();
    },
    setBrand(brand) {
      this.$refs.ecu.setBrand(brand);
    },
  },
};
</script>

